module.exports = "<div class=\"js-grid-region\"></div>\n<div class=\"js-quantity-warning-region\"></div>";